import Defaults from '~/scripts/constants/defaults';
import Lang from './lang';

/**
 * @class
 * @typedef {Link} $LinkModel
 */
export default class Link {
	/**
	 * @class
	 * @param {any} link
	 */
	constructor(
		link = undefined,
	) {
		/** @type {number} */
		this.card_from = link === undefined ? 0 : Number.parseInt(link.card_from, 10);

		/** @type {number} */
		this.card_to = link === undefined ? Defaults.KCARDN : Number.parseInt(link.card_to, 10);

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.class_kid = link?.class_kid;

		/** @type {string} */
		this.data = link?.data || '';

		/** @type {?('from' | 'to')} */
		this.flow = link?.flow || null;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.inherits_from = link?.inherits_from;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.isa = link?.isa;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.isa_name_type_kid = link?.isa_name_type_kid;

		/** @type {string | undefined} */
		this.isaname = link?.isaname;

		/** @type {import('@knitiv/api-client-javascript').KLinkId | '0' | undefined} */
		this.kid = link?.kid;

		/** @type {number} */
		this.kright = link?.kright ?? 0;

		this.lang = new Lang(link?.lang);

		/** @type {import('@knitiv/api-client-javascript').LinkerKNode} */
		this.linker_kid = link === undefined ? '0' : link.linker_kid;

		/** @type {{name?: ?string}} */
		this.linker_info = link?.linker_info ?? { name: null };

		/** @type {boolean} */
		this.lock = link?.lock === 1 || false;

		/** @type {string | undefined} */
		this.name = undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.name_type_kid = link?.name_type_kid;

		/** @type {string | undefined} */
		this.objname = link?.objname;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.objnum_isa = link?.objnum_isa;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.objnum_kid = link?.objnum_kid ?? link?.objnum;

		/** @type {any} */
		this.objnum2_info = link?.objnum2_info;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.objnum2_isa = link?.objnum2_isa;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.objnum2_kid = link?.objnum2_kid ?? link?.objnum2;

		/** @type {number} */
		this.order = link?.order || 0;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.relation_kid = link?.relation_kid;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.type_kid = link?.type_kid;

		/** @type {any[]} */
		this.wf = link?.wf || [];
	}

	export() {
		return {
			linker_kid:   this.linker_kid,
			class_kid:    this.objnum2_kid,
			relation_kid: this.relation_kid,
		};
	}

	/**
	 * @returns {string}
	 */
	getName() {
		if (this.name) {
			return this.name;
		}
		let name = this.objnum2_info.name ?? '';
		if (this.linker_kid !== '0' && this.linker_info.name) {
			name += `:: ${this.linker_info.name}`;
		}
		return name;
	}

	getId() {
		return `${this.relation_kid}|${this.objnum2_kid}::${this.linker_kid}`;
	}
}
